import React, { useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import { useMsal, useIsAuthenticated } from "@azure/msal-react";
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { loginRequest } from '../../auth/msalConfig';
import { LoginCard, LoginContainer, SSOButton } from '../../styles/commonStyles';

const LoginPage: React.FC = () => {
  const { t } = useTranslation();
  const { instance, accounts } = useMsal();
  const navigate = useNavigate();
  const isAuthenticated = useIsAuthenticated();

  useEffect(() => {
    const currentAccount = instance.getActiveAccount();
    if (isAuthenticated && currentAccount) {
      navigate('/');
    } else if (accounts.length > 0) {
      // If we have accounts but no active account, set the first one as active
      instance.setActiveAccount(accounts[0]);
    }
  }, [isAuthenticated, accounts, instance, navigate]);

  const handleLogin = async () => {
    try {
      const loginScopes = (loginRequest.scopes || []).filter((scope): scope is string => typeof scope === 'string');
      await instance.loginRedirect({
        ...loginRequest,
        scopes: loginScopes
      });
    } catch (error) {
      console.error('Login failed:', error);
    }
  };

  return (
    <LoginContainer>
      <LoginCard>
        <Box mb={4}>
          <Typography variant="h4" fontWeight={600} color="#0078d4" mb={2}>
            {t('loginPage.welcome', 'Welcome')}
          </Typography>
          <Typography variant="body1" color="text.secondary">
            {t('loginPage.signIn', 'Sign in to access your account')}
          </Typography>
        </Box>
        <SSOButton
          variant="contained"
          onClick={handleLogin}
          fullWidth
        >
          {t('loginPage.loginButton', 'Login with SSO')}
        </SSOButton>
      </LoginCard>
    </LoginContainer>
  );
};

export default LoginPage;
